import React from 'react';
import { useStyletron } from 'baseui';

import { EMPTY_OBJECT, FormBuilder } from 'commons-ui';
import { FORM_FIELD_CONFIG, FORM_LAYOUT_CONFIG, validationSchema } from '../../utils/formConfig';
import { ContentPropsT } from '../../kindReward.model';
import useFilter from '../../utils/useFilter';

const Content = (props: ContentPropsT) => {
	const { handleFilterSubmit, onClose, handleRewardCredit } = props;
	const [css] = useStyletron();

	const { showLoader, setShowLoader, handleFormSubmit, handleFormCancel } = useFilter({
		handleFilterSubmit,
		onClose,
		handleRewardCredit
	});

	return (
		<div className={css({ width: '50vw' })}>
			<FormBuilder
				data={EMPTY_OBJECT}
				mode='create'
				showLoader={showLoader}
				handleFormSubmit={handleFormSubmit}
				handleFormCancel={handleFormCancel}
				setShowLoader={setShowLoader}
				fieldConfig={FORM_FIELD_CONFIG}
				layoutConfig={FORM_LAYOUT_CONFIG}
				buttonLabels={{
					submitLabel: 'Submit',
					discardLabel: 'Cancel'
				}}
				hidePopUp
				validationSchema={validationSchema}
			/>
		</div>
	);
};

export default Content;
